export default "__VITE_ASSET__tL9jjVXb__"